

<mat-toolbar *transloco="let t">
  <div class="flex flex-row items-center h-full">
    <img src="assets/img/my_account_logo.svg" alt="My Account" />
    <mat-divider [vertical]="true"></mat-divider>
    <img *ngIf="client$ | async as client" [alt]="client?.name " [src]="client?.logo?.url" >
  </div>

  <!--  <img routerLink=" /auth/check" src="assets/img/mcompany_logo_white.svg" alt="MobilityCity" />-->
  <!--  <mat-divider vertical></mat-divider>-->

  <!--  <img *ngIf="urlLogo" class="customlogo" height="100%" [src]="urlLogo" alt="MobilityCity" />-->

  <!--  <span class="spacer"></span>-->
  <div class="flex flex-row items-center h-full">
  <button class="user-menu-button" mat-button [matMenuTriggerFor]="menu">
    <mat-icon>person</mat-icon>
  </button>
    <mat-menu #menu="matMenu">
<!--      <button mat-menu-item routerLink="/profile">{{'menu.profile' | translate}}</button>-->
      <button mat-menu-item (click)="onLogout()">{{t('logout')}}</button>
    </mat-menu>
    <mat-divider [vertical]="true"></mat-divider>
    <mat-select class="language-selector" [value]="selectedLanguage" (valueChange)="setLanguage($event)" >

      <mat-option  [value]="lang" *ngFor="let lang of availableLanguages">
        {{lang | uppercase}}
      </mat-option>

    </mat-select>

  </div>
</mat-toolbar>
